import type { LibraryStore } from "../data/store";
import type { Id, Library } from "../domain/types";

export type View = "loading" | "login" | "load-error" | "welcome" | "home" | "cat" | "settings" | "plans";
/** view state; not saved */
export interface ViewState { view: View; catId: Id | null; edit: boolean }

/** data saved in this browser before signing in, offered for a move into the account */
export interface LocalOffer { library: Library; own: number; sample: number }

export const ctx = {
  store: null as unknown as LibraryStore,
  V: { view: "home", catId: null, edit: false } as ViewState,
  render: () => {},
  /** "local": no Supabase configured, data only in this browser (Queue 2). "cloud": account required. */
  mode: "local" as "local" | "cloud",
  /** signed-in account in cloud mode */
  account: null as { id: string; email: string; methods?: string[] } | null,
  /** the session ended without a log out (expired); the screen is kept, saving needs a new sign-in */
  sessionLost: false,
  localOffer: null as LocalOffer | null
};
